import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  reloadIcon: {
    marginBottom: '0.5rem',
  },
  modalNotes: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  modalNote: {
    color: colors.neutral.black,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
